export enum UserRoleEnum {
  admin = "admin",
  accountant = "accountant",
  morderator = "moderator",
  merchant = "merchant",
  sAdmin = "sAdmin",
  partnerChain = "partner_chain",
  partnerStore = "partner_store",
  partnerForeign = "partner_foreign",
  user = "user",
  partner = "partner"
}
